// removed by extract-text-webpack-plugin
module.exports = {"Preview":"Preview___ADVqG","btn":"btn___1z7OR","bg":"bg___r7dS1","wrapper":"wrapper___21XoL","header":"header___3kykZ","h3":"h3___3cjBf","h4":"h4___1_vUG","close":"close___3-gfl","content":"content___EF5d6","currentTab":"currentTab___3tFPd","reload":"reload___JdGcp"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/ItemPreview/styles.scss
// module id = 456
// module chunks = 0